import { Check, Clock3, Lock, Play, Sparkles } from 'lucide-react';
import { Link } from 'react-router-dom';
import { motion } from 'motion/react';
import { curriculum, phases } from '../content/curriculum';
import { useProgress } from '../app/ProgressContext';

export function RoadmapPage() {
  const { progress } = useProgress();
  const currentDay = curriculum.find((day) => progress.days[day.day]?.status !== 'completed')?.day ?? 60;

  return (
    <div className="page roadmap-page">
      <header className="page-heading split"><div><span className="eyebrow">THE COMPLETE PATH</span><h1>Your 60-day roadmap</h1><p>Four deliberate phases. One stronger version of you.</p></div><div className="roadmap-summary"><strong>{progress.stats.completedDays}<span>/60</span></strong><small>days completed</small></div></header>
      <div className="roadmap-legend"><span><i className="complete" /> Complete</span><span><i className="current" /> Current</span><span><i /> Up ahead</span></div>
      <div className="roadmap-phases">
        {phases.map((phase, phaseIndex) => {
          const days = curriculum.filter((day) => day.phaseNumber === phase.number);
          const complete = days.filter((day) => progress.days[day.day]?.status === 'completed').length;
          return (
            <motion.section key={phase.number} className={`roadmap-phase phase-${phase.number}`} initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: phaseIndex * .06 }}>
              <header><div className="phase-number" style={{ '--phase-color': phase.color } as React.CSSProperties}>0{phase.number}</div><div><span>{phase.range}</span><h2>{phase.name}</h2></div><div className="phase-progress"><span>{complete} of {days.length}</span><div><i style={{ width: `${complete / days.length * 100}%`, background: phase.color }} /></div></div></header>
              <div className="day-grid">{days.map((day) => {
                const done = progress.days[day.day]?.status === 'completed';
                const current = day.day === currentDay;
                const future = day.day > currentDay;
                return <Link to={`/day/${day.day}`} key={day.day} className={`day-tile ${done ? 'done' : ''} ${current ? 'current' : ''} ${future ? 'future' : ''}`}>
                  <div className="tile-top"><span>{done ? <Check /> : current ? <Play fill="currentColor" /> : <Lock />}</span><small>DAY {String(day.day).padStart(2, '0')}</small></div>
                  <h3>{day.title}</h3>
                  <div className="tile-meta"><span><Clock3 /> {day.minutes}m</span><b>{day.difficulty}</b></div>
                  {current && <em><Sparkles /> You are here</em>}
                </Link>;
              })}</div>
            </motion.section>
          );
        })}
      </div>
    </div>
  );
}

